import React from 'react';
import "./Paragraph.css";

const Paragraph = () => {
    return (<textarea className='create-input mt-30' name="" id="" cols="5" rows="5" placeholder='type your answer'></textarea>
        
    )
}

export default Paragraph;